<template>
  <div id="app">
    <Main />
	<!-- <div>
		<div v-if="authState !== 'signedin'">You are signed out.</div>
		<amplify-authenticator>
			<div v-if="authState === 'signedin' && user">
				<div>Hello, {{user.username}}</div>
			</div>
			<amplify-sign-out></amplify-sign-out>
		</amplify-authenticator>
	</div> -->
  </div>
</template>

<script>
import Main from './views/Main.vue'
import { onAuthUIStateChange } from '@aws-amplify/ui-components'

export default {
  name: 'app',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Eismann Business Intelligence',
    // all titles will be injected into this template
    titleTemplate: '%s | EBI'
  },
  components: {
    Main
  },
  created() {
    // this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
    //   this.authState = authState;
    //   this.user = authData;
    // });

    console.log("mode", process.env.NODE_ENV);
  },
  // data() {
  //   return {
  //     user: undefined,
  //     authState: undefined,
  //     unsubscribeAuth: undefined
  //   }
  // },
  // beforeDestroy() {
  //   this.unsubscribeAuth();
  // }
}
</script>

<style>
#app {

}
</style>
